// export * from "./Filter";
// export * from "./interfaces";
// work around TypeScript bug, should be able to be removed in TS 2.7
/// <amd-module name="SearchUI/Utilities/Filter" />
export {
    Filter,
    FILTER_APPLIED_EVENT,
    FILTER_CHANGE_EVENT,
    FILTER_RESET_EVENT,
} from "./Filter/Filter";
export {
    FilterOperatorType,
    IFilter,
    IFilterItemState,
    IFilterOptions,
    IFilterState,
} from "./Filter/interfaces";
